module.exports = __webpack_public_path__ + "7b3092647a0568c2793a792124ccbf87.svg";